import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import TicketAttributeValue from 'models/ticket-attribute-value/ticket-attribute-value.model';
import TicketAttribute from 'models/ticket-attribute/ticket-attribute.model';
import TicketCategory from 'models/ticket-category/ticket-category.model';
import TicketStatus from 'models/ticket-status/ticket-status.model';
import Ticket from 'models/ticket/ticket.model';
import { GeoCodeService } from 'services/geocode/geocode.service';
import { TicketService } from 'services/ticket/ticket.service';
import * as moment from 'moment';

@Component({
  selector: 'app-ticket-attribute-card',
  templateUrl: './ticket-attribute-card.component.html',
  styleUrls: ['./ticket-attribute-card.component.scss'],
})
export class TicketAttributeCardComponent implements OnInit {
  @Input() ticketAttributeValue: TicketAttributeValue = new TicketAttributeValue();

  public ticket = new Ticket();
  public attributeList: TicketAttribute[] = [];
  public statuses: TicketStatus[] = []
  public categories: TicketCategory[] = [];
  private buffered = () => {};
  public searchList: string[] = [];

  constructor(
    private ticketService: TicketService,
    private geoCodeService: GeoCodeService,
    private dialogRef: MatDialogRef<TicketAttributeCardComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.ticket = data.ticket;
    this.attributeList = data.attributeList;
    this.statuses = data.statuses;
    this.categories = data.categories;
  }

  ngOnInit() {
    let attrValList: TicketAttributeValue[] = [];
    this.ticket.ticketAttributeValues.forEach((ticketAttributes) => {
      const hasPossValues = this.attributeList.find((attributeFromList) => attributeFromList.id === ticketAttributes.ticketAttribute.id);
      attrValList.push(new TicketAttributeValue({
        ...ticketAttributes,
        ticketAttribute: hasPossValues 
          ? new TicketAttribute({
            ...hasPossValues,
            possibleValues: hasPossValues.possibleValues,
          })
          : new TicketAttribute({
            ...ticketAttributes.ticketAttribute,
            possibleValues: ticketAttributes.value,
            disabled: true,
          }),
      }));
    });

    this.attributeList.forEach((attr) => {
      const hasAttribute = attrValList.find((attributeFromList) => attributeFromList.ticketAttribute.id === attr.id);
      if (!hasAttribute) {
        attrValList.push(new TicketAttributeValue({
          ticketAttribute: attr,
        }));
      }
    });

    this.ticket = new Ticket({
      ...this.ticket,
      ticketAttributeValues: attrValList,
    });
  }

  buffer() {
    this.buffered();
    new Promise((resolve, reject) => {
      this.buffered = reject;
      setTimeout(resolve, 300);
    }).then(() => this.geoCodeService.getAddressHints(this.ticket.address).then((geos) => this.searchList = geos.map((geo) => geo.properties.address)))
    .catch(console.log);
  }

  update() {
    this.ticketService.get(this.ticket.id).then((ticket: Ticket) => {
      this.ticket.position.geometry.coordinates = ticket.position.geometry.coordinates;
      this.ticketService.update(this.ticket).then(() => this.dialogRef.close(true));
      this.ticketService.updateTicketCategory(this.ticket);
      this.ticketService.setStatus(this.ticket, this.ticket.ticketStatus);
      this.ticketService.updateDescription(this.ticket);
    });
  }

  isChecked(att, value) {
    return att.value.includes(value);
  }

  getValueDate(date) {
    return moment(+date).toISOString();
  }

  getAttribute(attr: TicketAttributeValue) {
    return this.attributeList.find((a) => a.id === attr.ticketAttribute.id);
  }

  getValue() {
    return this.categories.find((cat) => this.ticket.ticketCategory.id === cat.id);
  }

  changeStatus(value: string) {
    this.ticket.ticketStatus = this.statuses.find((status) => value === status.name);
  }

  changeCat(cat: TicketCategory) {
    this.ticket.ticketCategory = cat;
  }
  
  changeAttribute(value: string, ticketAttribute: TicketAttributeValue) {
    this.ticket.ticketAttributeValues = this.ticket.ticketAttributeValues.map((attributeValue) =>
      attributeValue.ticketAttribute.id === ticketAttribute.ticketAttribute.id
        ? new TicketAttributeValue({ ...attributeValue, value: [value] })
        : attributeValue  
    );
  }

  changeMultiAttribute(value: string, ticketAttribute: TicketAttributeValue) {
    this.ticket.ticketAttributeValues = this.ticket.ticketAttributeValues.map((attributeValue) =>
      attributeValue.ticketAttribute.id === ticketAttribute.ticketAttribute.id
        ? new TicketAttributeValue({ ...attributeValue, value: attributeValue.value.includes(value) ? attributeValue.value.filter((val) => val !== value) : [...attributeValue.value, value] })
        : attributeValue  
    );
  }

  fillDate(value, ticketAttribute) {
    this.ticket.ticketAttributeValues = this.ticket.ticketAttributeValues.map((attributeValue) => {
      return attributeValue.ticketAttribute.id === ticketAttribute.ticketAttribute.id
        ? new TicketAttributeValue({ ...attributeValue, value: [moment(value).valueOf().toString()] })
        : attributeValue
    });
  }
}
